import { VerificationDocumentTypes } from 'types';

export const getVerifyDocumentError = (type: VerificationDocumentTypes): string => {
  switch (type) {
    case VerificationDocumentTypes.PAN_CARD:
      return 'Your pancard is invalid. Please, enter the valid pancard number.';

    case VerificationDocumentTypes.DRIVING_LICENCE:
      return 'Your driving licence is invalid. Please, enter the valid driving licence number.';

    case VerificationDocumentTypes.VOTER_ID:
      return 'Your voter ID is invalid. Please, enter the valid voter ID number.';

    default:
      return '';
  }
};
